import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_KHORNE: {
    name: 'Battletome: Blades of Khorne',
    type: 'battletome',
  },
  ERRATA_APRIL_2023: {
    name: 'Errata (April 2023)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2023/04/PF2QaiUfiT3X0VQR.pdf',
  },
} satisfies TRuleSources

export default rule_sources
